/**
 * Device File Constants
 * @description デバイスファイル管理機能の定数定義
 */

// ============================================
// ファイル名バリデーション
// ============================================

/**
 * ファイル名の最大長
 */
export const MAX_FILE_NAME_LENGTH = 255;

/**
 * ファイル名に使用できない文字の正規表現
 * Windows/Unix共通の禁止文字: < > : " / \ | ? *
 */
export const INVALID_FILE_NAME_CHARS = /[<>:"/\\|?*]/;

/**
 * 制御文字の範囲（U+0000-U+001F）
 */
const CONTROL_CHAR_START = 0x00;
const CONTROL_CHAR_END = 0x1f;

/**
 * ファイル名に制御文字が含まれているかチェック
 */
export function hasControlCharacters(fileName: string): boolean {
  for (let i = 0; i < fileName.length; i++) {
    const code = fileName.charCodeAt(i);
    if (code >= CONTROL_CHAR_START && code <= CONTROL_CHAR_END) {
      return true;
    }
  }
  return false;
}

// ============================================
// ページネーション
// ============================================

/**
 * デフォルトのページサイズ
 */
export const DEVICE_FILE_PAGE_SIZE = 100;

// ============================================
// フォルダタイプ
// ============================================

/**
 * デバイスファイルのフォルダタイプ一覧
 */
export const DEVICE_FOLDER_TYPES = ['INSTALLATION', 'RETRIEVAL', 'ASSIGNMENT', 'RETURN', 'RECEIVING', 'INITIAL_SETUP', 'INVENTORY', 'REPAIR', 'REPLACEMENT', 'DISPOSAL', 'DOCUMENT'] as const;